<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Générer mails collecte pièces comptables
        </div>

        <div slot="body">
            <div
                v-if="items && items.length > 0"
                class="h6"
            >
                Un mail sera envoyé aux clients ci-dessous:
            </div>

            <base-table
                :items="items"
                :meta="meta"
                :params="exParams"
                :loading="loading"
                :head="{client: 'Client', email: 'Email', is_mail_simplifie: 'Type'}"
                name="mail"
                class="mt-3"
                no-export
                @orderBy="orderBy"
                @change-page="goToPage"
            >
                <div slot="before" />

                <tr
                    v-for="dossier of items"
                    :key="dossier.id"
                >
                    <td>
                        <template v-if="dossier.client.is_indivision">
                            {{ dossier.client.type_indivision }} {{ dossier.client.libelle_indivision }}
                        </template>

                        <template v-else>
                            {{ dossier.client.nom }} {{ dossier.client.prenom }}
                        </template>
                    </td>

                    <td>{{ dossier.client.email }}</td>

                    <td>{{ dossier.is_mail_simplifie ? 'Simplifié': 'Classique' }}</td>

                    <td class="text-center">
                        <router-link
                            :to="{name: 'dossier', params: {id: dossier.id}}"
                            class="btn btn-primary btn-sm"
                            title="Voir"
                        >
                            <i class="fa fa-glasses" />
                        </router-link>
                    </td>
                </tr>

                <div slot="no-results">
                    <div class="text-center h3 mt-5 pt-5">
                        Aucun mail à envoyer...
                    </div>
                </div>
            </base-table>
        </div>

        <div
            v-if="items && items.length > 0"
            slot="footer"
        >
            <button
                v-btn-loading="sendingMails"
                class="btn btn-success"
                @click="sendMails"
            >
                Envoyer
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import DossierSearch from "../../mixins/DossierSearch"
    import BaseTable from "../templates/BaseTable"

    export default {
        name: "GenererMailsCollecteModal",
        components: {BaseTable, BaseModal},

        mixins: [DossierSearch],

        props: {
            additionalParams: {type: Object, default: () => {return {}}}
        },

        data: function () {
            return {
                params: {
                    ...this.additionalParams,
                    statuts: [this.$store.state.dossiersStatuts.statutMailAEnvoyerId],
                    mailsAutorises: 1,
                    actif: 1,
                    clientSorti: 0,
                    dossierSorti: 0,
                },
                sendingMails: false,
            }
        },

        methods: {
            /**
             * Génère et envoie les mails de collectes aux clients
             */
            sendMails: function () {
                this.sendingMails = true
                axios.post('/api/mails/send-mails-collectes', this.params).then(() => {
                    this.sendingMails = false
                    this.$notify('success', "Les mails ont bien été générés et seront envoyés aux clients d'ici quelques minutes.")
                    this.$emit('close')
                }).catch(() => {
                    this.sendingMails = false
                    this.$notify('danger', "Une erreur est survenue lors de la génération des mails.")
                })
            }
        }
    }
</script>
